import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { setCredentials } from './../../helpers/auth/storageAuth'
import { serializeAuth } from './../../helpers/serializers/auth'
import { signInRequest } from '../../api/auth'

class SignIn extends Component {
    constructor (props) {
        super(props)
        this.state = {
          email: null,
          password: null,
          error: null
        }
    }
    
    handleKeyPress = ev => {
        if (ev.key === 'Enter') {
            this.state.email.trim() && this.state.password && this.submit()
        }
    }

    handleInformationInput = evt => {
        this.setState({
            [evt.target.name]: evt.target.value
        })
    }

    signInSuccess = (data) => {
        const auth = serializeAuth(data)
        setCredentials(auth)
        this.props.history.push('/');
    }

    submit = () => {
        const user = {
          email: this.state.email,
          password: this.state.password
        }

        signInRequest(user, 
            result => this.signInSuccess(result),
            error => this.setState({ error: 'Invalid username or password.' })
        )
    }

    render () {

        const { email, password, error } = this.state

        return (
            <div style={{ textAlign: "center"}}>
                <div
                    style={{
                    margin: '50px auto',
                    padding: '40px',
                    width: '400px',
                    border: '1px solid #ccc'
                    }}
                >
                    <div className='form-group'>
                    <label>E-mail</label>
                    <input
                        className='form-control'
                        onKeyPress={this.handleKeyPress}
                        name='email'
                        type='email'
                        value={email || ''}
                        onChange={this.handleInformationInput}
                    />
                    </div>
                    <div className='form-group'>
                    <label>Password</label>
                    <input
                        className='form-control'
                        onKeyPress={this.handleKeyPress}
                        name='password'
                        type='password'
                        value={password || ''}
                        onChange={this.handleInformationInput}
                    />
                    </div>
                    {error &&
                        <div className="alert alert-danger mb-2">
                            {error}
                        </div>
                    }
                    <div>
                    <button
                        onClick={this.submit}
                        className='mt-2 btn btn-primary'
                        type='button'
                    >
                        Sign In
                    </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(SignIn)
